export const columnsTracking = [
  { id: "idEmpresa", title: "Empresa", width: "26%", position: "EMPDESXX" },
  { id: "idProceso", title: "Proceso", width: "20%", position: "AREADESX" },
  { id: "idTipos", title: "Tipos con orden", width: "12%", position: "TIPOSXXX" },
  { id: "idModificadoPor", title: "Modificado Por", width: "20%", position: "REGUSRNM" },
  { id: "idFechaModificacion", title: "Fecha de modificación", width: "12%", position: "REGFECMX" },
];

//Ids genericos de Tablexxx: abren el modal en VISUALIZAR / EDITAR
export const buttons = [
  { id: "idVerProceso", class: "bi bi-eye-fill", title: "Ver" },
  { id: "idEditarProceso", class: "bi bi-pencil-square", title: "Editar" },
];
